import React, {useEffect, useState} from 'react';
import {
    CCText,
    Image,
    ScrollView,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import TMenuItemScreen from './Translations/TMenuItemScreen';

import * as MaskFunctions from '@chocostack/maskifier';
import ActivityIndicatorWrapper from '../../../components/public/UI/ActivityIndicatorWrapper';
import AppConfig from '../../../AppConfig';
import {useParams} from 'react-router-dom';

const MenuItemScreen = (props) => {
    const params = useParams()
    const foodID = params.id;

    const [loading, setLoading] = useState(true);
    const [menuItem, setMenuItem] = useState({});
    const [ingredientGroups, setIngredientGroups] = useState([]);
    const [ingredients, setIngredients] = useState([]);
    const [extras, setExtras] = useState([]);

    useEffect(async () => {
        try {
            const response = await fetch(AppConfig.URL + '/Menu/FetchFood/' + foodID, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    //'Anonymous-Id': ls.get("anonymousId")
                },
            }
            );

            let data = await response.json();

            setLoading(false);
            setMenuItem(data.menuItem);
            setIngredientGroups(data.ingredientGroups);
            setIngredients(data.ingredients);
            setExtras(data.extras);

            return;
        } catch (error) {
            console.error(error);

            setLoading(false);
        }
    }, []);


    if (loading)
        return <ActivityIndicatorWrapper />

    return (
        <ScrollView style={{ height: '100%' }}>
            <View className="borderCard">
                <View
                    style={{ margin: -10 }}
                >
                    {menuItem.foO_IMAGE ?
                            <Image
                                source={{ uri: menuItem.foO_IMAGE }}
                                style={{
                                    width: '100%',
                                    height: 300
                                }}
                            />
                        :
                            null
                        }
                </View>
                <CCText style={{ fontSize: 24, fontWeight: 'bold', marginTop: 15 }}>
                    {menuItem.foO_NAME}
                </CCText>
                <CCText style={{ fontSize: 18, color: 'gray' }}>
                    {menuItem.foO_DESCRIPTION}
                </CCText>
                <CCText style={{ textAlign: 'right', fontSize: 18, fontWeight: 'bold' }}>
                    {MaskFunctions.maskMoney(menuItem.foO_PRICE)}
                </CCText>
            </View>
            {ingredientGroups.length > 0 || ingredients.length > 0 || extras.length > 0 ?
                <CCText style={{ fontSize: 21, fontWeight: 'bold', marginTop: 15 }}>
                    {TMenuItemScreen[AppConfig.lang].INGREDIENTS}
                </CCText>
                :
                null
            }
            {ingredientGroups.length > 0 ?
                <View>
                    <CCText className="theme-color" style={{ fontSize: 17, fontWeight: 500 }}>
                        {TMenuItemScreen[AppConfig.lang].MAIN}
                    </CCText>
                    <View className="borderCard" style={{ padding: 15 }}>
                        {
                            ingredientGroups.map(item => <View
                                key={item.fiG_ID}
                                style={{ marginTop: 5, marginBottom: 5 }}
                            >
                                <CCText style={{ fontSize: 19, fontWeight: 'bold' }}>
                                    {item.ingredientGroup.igR_NAME}
                                </CCText>
                                <CCText style={{ fontSize: 15, fontStyle: 'italic', fontWeight: 500 }}>
                                    ({TMenuItemScreen[AppConfig.lang].ONLY_ONE})
                                </CCText>
                                {item.ingredientGroup.ingredientGroupItems.map(igi => <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <CCText style={{ fontSize: 17, marginLeft: 15 }}>
                                        -{igi.ingredient.inG_NAME}
                                    </CCText>
                                    {
                                        igi.igI_PRICE ?
                                            <CCText style={{ fontSize: 17, fontWeight: 'bold' }}>
                                                +{MaskFunctions.maskMoney(igi.igI_PRICE)}
                                            </CCText>
                                            :
                                            <CCText style={{ fontSize: 17 }}>
                                                {TMenuItemScreen[AppConfig.lang].FREE}
                                            </CCText>
                                    }
                                </View>)}
                            </View>)
                        }
                    </View>
                </View>
                :
                null
            }
            {ingredients.length > 0 ?
                <View style={{ marginTop: 15 }}>
                    <CCText className="theme-color" style={{ fontSize: 17, fontWeight: 500 }}>
                        {TMenuItemScreen[AppConfig.lang].OPTIONAL}
                    </CCText>
                    <View className="borderCard" style={{ padding: 15 }}>
                        {
                            ingredients.map(item => <CCText
                                key={item.fiG_ID}
                                style={{ fontSize: 19 }}
                            >
                                -{item.ingredient.inG_NAME}
                            </CCText>)
                        }
                    </View>
                </View>
                :
                null
            }
            {extras.length > 0 ?
                <View style={{ marginTop: 15, marginBottom: 25 }}>
                    <CCText className="theme-color" style={{ fontSize: 17, fontWeight: 500 }}>
                        {TMenuItemScreen[AppConfig.lang].EXTRA_INGREDIENTS}
                    </CCText>
                    <View className="borderCard" style={{ padding: 15 }}>
                        {
                        extras.map(item =>
                            <View style={{ flex: 1, flexDirection: 'row', justifyContent: 'space-between' }}>
                                <CCText style={{ fontSize: 19 }}>
                                    -{item.extra.exT_NAME}
                                </CCText>
                                <CCText style={{ fontSize: 19, fontWeight: 'bold' }}>
                                    +{MaskFunctions.maskMoney(item.extra.exT_PRICE)}
                                </CCText>
                            </View>)
                        }
                    </View>
                </View>
                :
                null
            }
        </ScrollView>
    );
}

export default MenuItemScreen;